import type { MeasurementValue } from '@/types/measurements';
import { formatMeasurement } from '@/types/measurements';
import { useAppStore } from '@/lib/store';
import { ConfidenceBadge } from './ConfidenceBadge';

interface MeasurementRowProps {
  label: string;
  value: MeasurementValue;
}

export function MeasurementRow({ label, value }: MeasurementRowProps) {
  const unitSystem = useAppStore((s) => s.unitSystem);
  return (
    <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-600">{label}</span>
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-gray-900">
          {formatMeasurement(value.valueCm, unitSystem)}
        </span>
        <ConfidenceBadge level={value.confidenceLevel} />
      </div>
    </div>
  );
}
